
import { Component, Vue, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import MainHeader from "@/components/main-header.vue";
import NavLeft from "@/components/nav-left.vue";
import axios from "@/plugins/axios";
import { GetIdArr } from "@/utils/base";
import {
  PostAddTem,
  PatchEditTem,
  GetDictionaryData,
  GetTemList,
  GetTemCreatorList,
  DelTem,
  ImportTem,
} from "@/request/common";
import ReportSuggest from "../components/report-suggest.vue";
import DictionaryManage from "../components/dictionary-manage.vue";
@Component({
  components: {
    MainHeader,
    NavLeft,
    ReportSuggest,
    DictionaryManage,
  },
})
export default class Name extends mixins(listMixin) {
  private data: any[] = [];
  private types: any[] = [];
  private creators: any[] = [];
  private scoreFunList: any[] = [];
  private temTypes: any[] = [];
  private editCrfData: any = {};
  private edit: any = false;
  private ifShowAddLiangbiao: any = false;
  private ifShowBaogaoManage: any = false;
  private reportType: any = [];
  private ifShowManage: any = false;
  private get user() {
    return this.$store.state.user;
  }
  private get patient() {
    return this.$store.state.patient;
  }
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private change(e: any) {
    if (!e) {
      this.editCrfData.jifen_func = {};
    }
  }
  private saveManage() {
    this.getType();
  }
  private changeReport() {
    this.editCrfData.result_rule = [];
  }
  private openReportManage(item: any) {
    this.editCrfData = JSON.parse(JSON.stringify(item));
    this.ifShowBaogaoManage = true;
  }
  private getType() {
    const params: any = {
      params: {
        values: "量表模板类型",
        statue: true,
      },
    };
    GetDictionaryData(this, params).then((res: any) => {
      this.types = res.data;
    });
  }
  private addOneResult() {
    if (!this.editCrfData.result_rule) {
      this.editCrfData.result_rule = [];
    }
    const obj = {
      min: "",
      max: "",
      result: "",
      suggest: "",
    };
    this.editCrfData.result_rule.push(obj);
  }
  private updateSuggest(e: any, index: any) {
    this.editCrfData.result_rule[index] = e;
  }
  private delOne(index: any) {
    this.$confirm("您是否确定删除当前内容？", "删除", {
      customClass: "commonConfirm",
    }).then(() => {
      this.editCrfData.result_rule.splice(index, 1);
    });
  }
  private saveBaogaoManage() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      result_rule: this.editCrfData.result_rule,
      report_type: this.editCrfData.report_type,
    };
    PatchEditTem(this, this.editCrfData.id, params, loading).then(
      (res: any) => {
        this.$message.success("保存成功");
        this.getList();
        this.ifShowBaogaoManage = false;
      }
    );
  }
  private switchChange(item: any) {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      is_mobile: item.is_mobile,
    };
    PatchEditTem(this, item.id, params, loading).then((res: any) => {
      this.$message.success("修改成功");
      this.search();
    });
  }
  private uploadFile(d: any) {
    const fileObj = d.file;
    // FormData 对象
    const form = new FormData();
    // 文件对象
    form.append("file", fileObj);
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    ImportTem(this, form, loading)
      .then((data: any) => {
        loading.close();
        this.$message.success("导入成功!");
        this.getList();
      })
      .catch(() => {
        loading.close();
      });
  }
  private exportTem(item: any) {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      id: item.id,
    };
    axios({
      url: `${this.systemInfo.GLOBAL_API_ROOT}api/crf/template/export_data/`,
      method: "GET",
      params: params,
      responseType: "blob", // 告诉axios期望服务器返回的数据类型
    }).then((response) => {
      loading.close();
      // 创建Blob对象
      // const blob = new Blob([response.data], { type: "application/msexcel" });
      const blob = new Blob([response.data], { type: "text/csv" });
      // 创建一个链接元素
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = item.name + ".csv"; // 设置下载文件名
      link.style.display = "none";
      // 将链接添加到文档中
      document.body.appendChild(link);
      // 触发点击事件以开始下载
      link.click();
      // 下载完成后，移除链接和释放内存
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    });
  }
  /**
   * @description 添加/编辑CRF量表保存
   */
  private saveEditCrf() {
    // 验证必填字段
    if (!this.editCrfData.name) {
      this.$message.warning("请输入量表名称");
      return;
    }
    if (!this.editCrfData.system_type || !this.editCrfData.system_type.label) {
      this.$message.warning("请选择模板类型");
      return;
    }
    if (!this.editCrfData.need_score && this.editCrfData.need_score !== false) {
      this.$message("请选择是否计分");
      return;
    }
    if (
      this.editCrfData.need_score &&
      (!this.editCrfData.jifen_func || !this.editCrfData.jifen_func.label)
    ) {
      this.$message("请选择计分方式");
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    if (this.editCrfData.id) {
      const params: any = {
        form_oid: this.editCrfData.form_oid,
        name: this.editCrfData.name,
        system_type: this.editCrfData.system_type,
        need_score: this.editCrfData.need_score,
        jifen_func: this.editCrfData.jifen_func,
        intro: this.editCrfData.intro,
        is_group: this.editCrfData.is_group,
        is_voice: this.editCrfData.is_voice,
        category: this.editCrfData.category,
      };
      PatchEditTem(this, this.editCrfData.id, params, loading).then(
        (res: any) => {
          this.$message.success("保存成功");
          this.search();
          this.ifShowAddLiangbiao = false;
        }
      );
    } else {
      PostAddTem(this, this.editCrfData, loading).then((res: any) => {
        this.$message.success("保存成功");
        this.search();
        this.ifShowAddLiangbiao = false;
      });
    }
  }
  /**
   * @description 打开添加/编辑CRF量表弹框
   */
  private openAddLiangbiao(item: any) {
    if (item) {
      this.editCrfData = JSON.parse(JSON.stringify(item));
      if (!this.editCrfData.jifen_func) {
        this.editCrfData.jifen_func = {};
      }
    } else {
      this.editCrfData = {
        need_score: false,
        jifen_func: {},
        fields: [],
        system_type: {},
        assess_type: {},
        report_type: {},
        category: [],
      };
      // 如果是superadmin可以选择模板类型，其他人默认自定义模板
      if (this.user.username != "superadmin") {
        this.temTypes.forEach((ele: any) => {
          if (ele.label == "自定义模板") {
            this.editCrfData.system_type = ele;
          }
        });
      }
    }
    // 获取计分函数
    this.getFuns();
    this.ifShowAddLiangbiao = true;
  }
  private getFuns() {
    const params: any = {
      params: {
        values: "计分方式",
        statue: true,
      },
    };
    GetDictionaryData(this, params).then((res: any) => {
      this.scoreFunList = res.data;
    });
  }
  private getReportType() {
    const params: any = {
      params: {
        values: "报告类型",
        statue: true,
      },
    };
    GetDictionaryData(this, params).then((res: any) => {
      this.reportType = res.data;
    });
  }
  private getTemType() {
    const params: any = {
      params: {
        values: "量表模板系统类型",
        statue: true,
      },
    };
    GetDictionaryData(this, params).then((res: any) => {
      this.temTypes = res.data;
    });
  }
  private getUsers(e: any) {
    GetTemCreatorList(this).then((res: any) => {
      this.creators = res.data;
    });
  }
  private goEdit(item: any) {
    this.$router.push({
      path: "/main/manage/tem-edit",
      query: {
        id: item.id,
      },
    });
  }
  private delTem(item: any) {
    this.$confirm("您是否确定删除当前量表？", "删除", {
      customClass: "commonConfirm",
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      DelTem(this, item.id, loading).then((res: any) => {
        this.$message.success("删除成功");
        this.getList();
      });
    });
  }
  getList() {
    console.log(this.filters);
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        ordering: this.filters.ordering,
        page: this.filters.current_page,
        limit: 10,
      },
    };
    if (this.filters.search) {
      params.params.name = this.filters.search;
    }
    if (this.filters["模板类型"] && this.filters["模板类型"].id) {
      params.params.system_type = this.filters["模板类型"].id;
    }
    if (this.filters["分类"] && this.filters["分类"].id) {
      params.params.category_ids = this.filters["分类"].id;
    }
    if (this.filters["创建人"] && this.filters["创建人"].length > 0) {
      params.params.creator_list = GetIdArr(this.filters["创建人"]).join(",");
    }
    localStorage.setItem("temListFilter", JSON.stringify(this.filters));
    GetTemList(this, params, loading).then((res: any) => {
      this.data = res.data;
      this.filters.total_count = res.total;
      if (this.data.length > 0) {
        this.ifShowEmpty = false;
      } else {
        this.ifShowEmpty = true;
      }
    });
  }
  mounted() {
    this.filters["系统模板"] = {};
    if (localStorage.getItem("temListFilter")) {
      this.filters = JSON.parse(localStorage.getItem("temListFilter") as any);
    }
    this.getList();
    this.getTemType();
    this.getReportType();
    this.getType();
  }
}
